import { delay } from '@/services/fetchDriver';
import {
  createMockSession,
  MOCK_GROUPS,
  MOCK_TICKET_TO_GROUP,
} from './mockData';
import type {
  EntrDataTransport,
  ListGroupsInput,
  ListGroupsOutput,
} from './types';

export function createMockEntrDataTransport(): EntrDataTransport {
  return {
    async listGroups(input: ListGroupsInput): Promise<ListGroupsOutput> {
      await delay(120);
      const pageCount = Math.max(
        1,
        Math.ceil(MOCK_GROUPS.length / input.pageSize)
      );
      const page = Math.min(Math.max(1, input.page), pageCount);
      const start = (page - 1) * input.pageSize;
      return {
        groups: MOCK_GROUPS.slice(start, start + input.pageSize),
        page,
        pageCount,
      };
    },

    async getSessionByGroup(groupId) {
      await delay(180);
      const group = MOCK_GROUPS.find((item) => item.id === groupId);
      if (!group) return { ok: false, reason: 'not-found' };
      if (group.photoState === 'not-ready') {
        return { ok: false, reason: 'photos-not-ready' };
      }
      return { ok: true, value: createMockSession(group, 'group') };
    },

    async getSessionByTicketCode(ticketCode) {
      await delay(240);
      if (ticketCode === 'SCAN-NOT-FOUND') {
        return { ok: false, reason: 'not-found' };
      }
      const groupId = MOCK_TICKET_TO_GROUP[ticketCode] ?? 'fdb';
      const group = MOCK_GROUPS.find((item) => item.id === groupId);
      if (!group) return { ok: false, reason: 'not-found' };
      if (group.photoState === 'not-ready') {
        return { ok: false, reason: 'photos-not-ready' };
      }
      return {
        ok: true,
        value: createMockSession(group, 'ticket', ticketCode),
      };
    },

    async recordPhotoPrinted() {
      await delay(120);
      return {
        ok: true,
        value: {
          groupId: 'mock-group',
          photosRequested: 1,
        },
      };
    },
  };
}
